module.exports = __webpack_public_path__ + "static/media/empty-component.02c111eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/empty-component.png
// module id = 548
// module chunks = 0